

























import { Component, Vue, Prop } from 'vue-property-decorator';

type Type = 'none' | 'outside'
type Allow = 'always' | 'never'

interface carouselConfig {
  height?: string,
  indicator?: Type,
  width?: string,
  name?: string,
  label?: string,
  allow?: Allow,
  direction?: string,
  interval?: number,
  loop?: boolean,
  autoplay?: boolean,
  trigger?: string,
  initialIndex?: number,
  isDirTop?: boolean,
  isDirLeft?: boolean,
  currentDirection?: string,
  items?: {
    name?: string,
    label?: string,
    data?: any
  }
}

@Component({
  name: 'dtCarousel'
})
export default class extends Vue {
  @Prop({ default: () => {} }) private config!: carouselConfig;
  @Prop() private extension?: (value: any) => void;
  private defaultConfig: any = {
    height: 100,
    indicater: 'none',
    direction: "bottom",
    autoplay: false,
    currentDirection: 'horizontal'
  };

  get currentConfig() {
    const result = this.config;
    Object.keys(this.defaultConfig).forEach((key: string) => {
      if (this.config[key] === undefined) result[key] = this.defaultConfig[key];
    });
    result.currentDirection =
      (result.direction === 'left' || result.direction === 'right') ? 'vertical' : 'horizontal';
    return result;
  }

  handleChange(newval, oldval) {
    this.$emit('on-change', newval, oldval);
  }
}
